import React, { memo, useMemo } from "react";
import { Icon } from '../../components';
import {Barbel as BarbelIcon} from '../../icons'
import { useMfwThemeProvider } from "myfitworld-utils";


const Barbel = () => {
  const fillColor = useMfwThemeProvider().mfwMuiWebTheme.palette.text.primary;

  const styes = useMemo(() => {
    return { stroke: 'none', fill: fillColor }
  }, [fillColor])

  return (
    <Icon icon={BarbelIcon} style={styes} />
  );
};

export default memo(Barbel);
